// Angular
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';
import {
  FormsModule
} from '@angular/forms';

// Material library
import {
  MatFormFieldModule
} from '@angular/material/form-field';
import {
  MatIconModule
} from '@angular/material/icon';

// Local library
import {
  IGetEventsDetailsResponse,
  IPool
} from '@amwager/util-ts';
import { BetAmountService } from '@amwager/wager/data-access';
import {
  FormatAmountPipe,
  NumberWithCommasPipe,
  TranslatePipe
} from '@amwager/util';
import {
  InputAmountComponent
} from './input-amount/input-amount.component';

// Third party
import _ from 'lodash';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'feature-mat-bets-amount',
  templateUrl: './bets-amount.component.html',
  styleUrls: ['./bets-amount.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    FormatAmountPipe,
    NumberWithCommasPipe,
    MatFormFieldModule,
    MatIconModule,
    TranslatePipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BetsAmountComponent implements OnInit, OnChanges {

  @Input() selectedEvent!: any;
  @Input() selectedPool!: IPool;
  @Output() doGetAmountFn = new EventEmitter<any>();

  selectedAmount: number = 0;
  betAmounts: number[] = [];
  minBet: number = 0;
  maxBet: number = 0;
  otherAmount: number = 0;

  // Race the default amount was last seeded for; distinguishes a real
  // race/event switch from a same-race pusher refresh.
  private currentRaceKey?: string;

  readonly dialog = inject(MatDialog);

  constructor(
    private readonly elementRef: ElementRef,
    readonly cdRef: ChangeDetectorRef,
    private readonly betAmountService: BetAmountService
  ) { }

  /**
   * Init on load
   * @returns {void}
   */
  ngOnInit(): void {
    null;
  }

  /**
   * Init after view loaded
   * @param {any} changes listen to data changes
   * @returns {void}
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (changes['selectedEvent'] !== undefined)
    {
      if (changes['selectedEvent'].currentValue) {
        const currentRace =
          changes['selectedEvent']?.currentValue?.ToteResponse?.EventDetail?.currentRace;
        const raceKey = `${changes['selectedEvent']?.currentValue?.id}-${currentRace?.RaceId}`;

        // Seed the default amount only on a real race/event change, so a
        // same-race pusher refresh doesn't reset the user's amount.
        if (raceKey !== this.currentRaceKey) {
          this.currentRaceKey = raceKey;
          this.selectedPool = currentRace?.Pools[0];

          const { showBetAmounts, minBet } = this.betAmountService.getBetAmounts(this.selectedPool);
          this.betAmounts = showBetAmounts;
          this.minBet = minBet;
          this.doGetAmountFn.emit(this.selectedPool?.WagerMinimum || 0);
        }
      }
    }

    if (changes['selectedPool'] !== undefined)
    {
      const prevPool = changes['selectedPool'].previousValue;
      const currPool = changes['selectedPool'].currentValue;

      // Reset the amount only when the pool actually changes — a
      // same-pool reference refresh (pusher) keeps the user's amount.
      if (currPool && currPool?.PoolId !== prevPool?.PoolId) {
        this.minBet = this.selectedPool.WagerMinimum;
        this.maxBet = this.selectedPool.WBMaximum;
        const { showBetAmounts, minBet } = this.betAmountService.getBetAmounts(this.selectedPool);
        this.betAmounts = showBetAmounts;
        this.minBet = minBet;
        this.selectedAmount = this.minBet || 0;
        this.doGetAmountFn.emit(this.selectedAmount);
      }
    }

    this.cdRef.markForCheck();
  }

  /**
   * Set event amount, add active class to the selected amount
   * @param {number} amount current amount
   * @param {any} id current DOM element
   * @returns {void}
   */
  chooseAmount(amount: number, id: number): void {

    // const checkActiveAmount = this.elementRef.nativeElement.querySelectorAll(
    //   '.current-bets-amount .active'
    // );

    // _.forEach(checkActiveAmount, (amount: HTMLElement) => {
    //   amount.classList.remove('active');
    // });

    // const activeAmount = this.elementRef.nativeElement.querySelector(
    //   '.current-bets-amount #id-' + id
    // );

    // activeAmount.classList.add('active');

    // const defaultIcon = this.elementRef.nativeElement.querySelectorAll(
    //   '.current-bets-amount .default'
    // );
    // const activeIcon = this.elementRef.nativeElement.querySelectorAll(
    //   '.current-bets-amount .active'
    // );

    // _.forEach(defaultIcon, (icon: HTMLElement) => {
    //   icon.classList.remove('tw-hidden');
    // });

    // _.forEach(activeIcon, (icon: HTMLElement) => {
    //   icon.classList.add('tw-hidden');
    // });

    // // const target = event.target;
    // const currentDefaultIcon = this.elementRef.nativeElement.querySelector(
    //   '.current-bets-amount .default#id-' + id
    // );
    // const currentActiveIcon = this.elementRef.nativeElement.querySelector(
    //   '.current-bets-amount .active#id-' + id
    // );

    // currentDefaultIcon.classList.add('tw-hidden');
    // currentActiveIcon.classList.remove('tw-hidden');

    this.selectedAmount = amount;
    this.otherAmount = 0;
    this.doGetAmountFn.emit(amount);
    this.cdRef.markForCheck(); // re-render for template
  }

  /**
   * Open dialog form to input amount
   * @returns {void}
   */
  inputAmount(): void {
    const dialogRef = this.dialog.open(InputAmountComponent, {
      data: this.minBet
    });

    dialogRef.afterClosed().subscribe((amount: any) => {
      this.selectedAmount = 0;
      this.otherAmount = Number(amount);
      this.doGetAmountFn.emit(Number(amount));
    });
  }

}
